@if(isLoading) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="msgLoader"></app-loader>
  </div>
}

<div class="p-6 max-w-7xl mx-auto overflow-x-hidden">

  <div class="flex flex-col lg:flex-row gap-6">

    <!-- Sidebar: Filtros -->
    <div class="lg:w-80 flex-shrink-0 space-y-4 overflow-hidden">
      <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 space-y-5 overflow-hidden">

        <h2 class="text-sm font-semibold text-mustard-700 dark:text-mustard-400 uppercase tracking-wide">
          <i class="pi pi-filter mr-1"></i> Filtros
        </h2>

        <!-- Fecha -->
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-2 block">Fecha de facturación</label>
          <div class="overflow-hidden"><p-datepicker [(ngModel)]="selectedDate" [inline]="true" [minDate]="minDate" [maxDate]="today" dateFormat="dd/mm/yy" /></div>
        </div>

        <!-- Fecha seleccionada -->
        <div class="bg-vivid-royal-50 dark:bg-vivid-royal-900 rounded-lg px-3 py-2 text-center">
          <p class="text-xs text-vivid-royal-400">Fecha seleccionada</p>
          <p class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">{{ selectedDate | date:'dd/MM/yyyy' }}</p>
        </div>

        <!-- Productos -->
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-2 block">Productos a facturar</label>
          <div class="space-y-3">
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" [(ngModel)]="regular" class="w-4 h-4 accent-vivid-royal-500 cursor-pointer" />
              <span class="text-sm text-vivid-royal-700 dark:text-vivid-royal-200">Regular</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" [(ngModel)]="premium" class="w-4 h-4 accent-vivid-royal-500 cursor-pointer" />
              <span class="text-sm text-vivid-royal-700 dark:text-vivid-royal-200">Premium</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" [(ngModel)]="diesel" class="w-4 h-4 accent-vivid-royal-500 cursor-pointer" />
              <span class="text-sm text-vivid-royal-700 dark:text-vivid-royal-200">Diesel</span>
            </label>
          </div>
        </div>

        <button pButton label="Preliminar" icon="pi pi-search" class="p-button-sm w-full"
          [disabled]="isInvoiced" (click)="searchInvoices()"></button>
      </div>
    </div>

    <!-- Main content -->
    <div class="flex-1 space-y-4">

      <!-- Empty state -->
      @if(taxRate16List.length === 0 && taxRate8List.length === 0 && !searched) {
        <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-12 text-center">
          <i class="pi pi-file text-4xl text-vivid-royal-300 mb-3"></i>
          <p class="text-sm text-vivid-royal-400">Haz clic en <strong>Preliminar</strong> para ver los consumos pendientes por facturar.</p>
        </div>
      }

      <!-- No results -->
      @if(taxRate16List.length === 0 && taxRate8List.length === 0 && searched) {
        <div class="bg-amber-50 dark:bg-amber-900/20 border border-amber-300 dark:border-amber-700 rounded-lg p-4 flex items-start gap-2">
          <i class="pi pi-info-circle text-amber-500 mt-0.5"></i>
          <p class="text-sm text-amber-700 dark:text-amber-300">{{ msgErrroConsumptionSearched }}</p>
        </div>
      }

      <!-- Preliminar view -->
      @if(!isInvoiced && (taxRate16List.length > 0 || taxRate8List.length > 0)) {

        <!-- Fiscal info notice -->
        <div class="bg-amber-50 dark:bg-amber-900/20 border border-amber-300 dark:border-amber-700 rounded-lg p-4 flex items-start gap-2">
          <i class="pi pi-exclamation-triangle text-amber-500 mt-0.5"></i>
          <p class="text-xs text-amber-700 dark:text-amber-300">
            Revisa tu información fiscal. Puedes corregir el código postal haciendo clic en él. Para otros datos fiscales, envía tu CSF a <strong>{{ contact?.emails?.invoicing }}</strong>
          </p>
        </div>

        <!-- Confirm & Invoice -->
        <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-4">
          <div class="flex items-center gap-3">
            <input type="checkbox" [(ngModel)]="isChecked" class="w-4 h-4 rounded border-dark-khaki-300 text-vivid-royal-500 focus:ring-vivid-royal-500 cursor-pointer" />
            <p class="text-sm text-vivid-royal-700 dark:text-vivid-royal-200 flex-1">
              He revisado los datos fiscales y consumos. Estoy de acuerdo en que, una vez emitido el CFDI, no será posible refacturar.
            </p>
            <button pButton label="Facturar" icon="pi pi-file-check" class="p-button-sm"
              [disabled]="!isChecked" (click)="clickInvoice()"></button>
          </div>
        </div>

        <!-- Invoice previews -->
        @if(taxRate8List.length > 0) {
          <div class="bg-white rounded-xl shadow-sm overflow-hidden">
            <app-invoice [client]="data.Client_number" [consumptions]="taxRate8List" [invoiceCompany]="station"
              [invoiceToCompany]="clientProfile" [dateInvoice]="selectedDate" [isInvoiced]="isInvoiced"></app-invoice>
          </div>
        }
        @if(taxRate16List.length > 0) {
          <div class="bg-white rounded-xl shadow-sm overflow-hidden">
            <app-invoice [client]="data.Client_number" [consumptions]="taxRate16List" [invoiceCompany]="station"
              [invoiceToCompany]="clientProfile" [isInvoiced]="isInvoiced" [dateInvoice]="selectedDate"></app-invoice>
          </div>
        }
      }

      <!-- Invoiced view -->
      @if(isInvoiced) {
        <div class="bg-white rounded-xl shadow-sm overflow-hidden">
          <app-invoice [client]="data.Client_number" [consumptions]="invoices" [invoiceCompany]="station"
            [invoiceToCompany]="clientProfile" [dateInvoice]="selectedDate" [isInvoiced]="isInvoiced"></app-invoice>
        </div>

        @if(isSuccess) {
          <div class="bg-green-50 border border-green-300 rounded-lg p-4 flex items-center justify-between">
            <div class="flex items-center gap-2">
              <i class="pi pi-check-circle text-green-500"></i>
              <p class="text-sm text-green-700">{{ responseInvoice.message }}</p>
            </div>
            <button pButton label="Reiniciar" icon="pi pi-refresh" class="p-button-sm p-button-outlined"
              (click)="isInvoiced=false;invoices=[];taxRate8List=[];taxRate16List=[];searched=false"></button>
          </div>
        }
      }

      <!-- Data error -->
      @if(isDataError && titleError !== '') {
        <div class="bg-red-50 border border-red-300 rounded-lg p-4 space-y-2">
          <div class="flex items-start gap-2">
            <i class="pi pi-times-circle text-red-500 mt-0.5"></i>
            <div>
              <p class="text-sm font-semibold text-red-700">{{ titleError }}</p>
              <p class="text-xs text-red-600 mt-1">Cliente: <strong>{{ data.Name }}</strong></p>
            </div>
          </div>
          <div class="mt-2">
            <p class="text-xs font-semibold text-red-700 mb-1">Acciones sugeridas:</p>
            <ul class="text-xs text-red-600 space-y-1 ml-4 list-disc">
              @for(action of suggestedActions; track $index) {
                <li><strong>{{ action.short }}:</strong> {{ action.long }}</li>
              }
            </ul>
          </div>
        </div>
      } @else if(isError && titleError !== '') {
        <div class="bg-red-50 border border-red-300 rounded-lg p-4 flex items-start gap-2">
          <i class="pi pi-times-circle text-red-500 mt-0.5"></i>
          <p class="text-sm text-red-700">{{ titleError }}</p>
        </div>
      }

    </div>
  </div>
</div>
